const STORAGE_KEY = 'ertzyx_pending_action';

export type PendingActionType =
  | 'follow'
  | 'like'
  | 'comment'
  | 'save'
  | 'circle_request'
  | 'witness'
  | 'reach_out';

export type PendingAction = {
  type: PendingActionType;
  targetUserId?: string;
  postId?: string;
  recordId?: string;
  circleId?: string;
  targetHandle?: string;
  returnTo: string;
};

export function savePendingAction(action: PendingAction): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(action));
  } catch {
    /* ignore quota */
  }
}

export function readPendingAction(): PendingAction | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as PendingAction;
  } catch {
    return null;
  }
}

export function clearPendingAction(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function consumePendingAction(): PendingAction | null {
  const action = readPendingAction();
  if (action) clearPendingAction();
  return action;
}

export function loginUrlWithReturn(returnTo: string, action?: PendingAction): string {
  if (action) savePendingAction(action);
  const next = encodeURIComponent(returnTo);
  return `/login?next=${next}`;
}
